export default {
  getTimeSheets() {
    const obj = {
      actionType: appConstants.ActionTypes.GET_TIMESHEETS,
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  approvePunches(punches) {
    const obj = {
      actionType: appConstants.ActionTypes.APPROVE_PUNCHES,
      postData: { punch_ids: punches },
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};
